import {Button, Input, Select} from "antd";
import {useEffect, useState} from "react";
import TimeIllustration from "../../../assets/illustrations/time-purple.png";
import "./step2.css";
import {PRESET_TRIGGER_DELAYS} from "./presetTriggerDelays";
import {PRESET_TRIGGER_DELAYS_UNITS} from "./presetTriggerDelaysUnits";
import {CloseOutlined, LeftOutlined, RightOutlined} from "@ant-design/icons";
import {FormValuesProps} from "../../modals/notificationModals/NewNotificationModal";
import TimePicker from "../../forms/timePicker/TimePicker";
import Step2Fields from "./Step2Fields";
import {useSteps} from "../../../hooks/useSteps";

interface StepProps {
    formValues: FormValuesProps;
    setFormValues: (values: FormValuesProps) => void;
    flowTriggerId: number;
}

const Step2 = ({ formValues, setFormValues, flowTriggerId }: StepProps) => {
    const { goBack, goNext } = useSteps();
    const { triggerDelay } = formValues;
    const setTriggerDelay = (newValue: number | null) => {
        setFormValues({ ...formValues, triggerDelay: newValue });
    }

    return <>
        <div className="step-container step-2">
            <div className="left">
                <div className="top">
                    <Step2Fields triggerDelay={triggerDelay} setTriggerDelay={setTriggerDelay} flowTriggerId={flowTriggerId} />
                </div>
                <div className="bottom">
                    <div className="buttons">
                        <Button type="default" size="large" className="back-step-button" onClick={() => goBack()} icon={<LeftOutlined />}>Back</Button>
                        <Button type="primary" size="large" className="next-step-button" onClick={() => goNext()} icon={<RightOutlined />} disabled={triggerDelay === undefined}>Next Step</Button>
                    </div>
                </div>
            </div>
            <div className="right">
                <img src={TimeIllustration} />
            </div>

        </div>
    </>
}

export default Step2;